module.exports = __webpack_public_path__ + "static/img/insurance-300x300.e95627d7.jpg";